export function trans(key, replace = {}) {
    try {
        let translation = key.split('.').reduce((t, i) => t[i] || null, window['translations']);

        for (const placeholder in replace) {
            translation = translation.replace(`:${placeholder}`, replace[placeholder]);
        }

        if(translation) {
            return translation;
        } else {
            return key;
        }
    } catch (e){
        return key;
    }
}